import React from 'react';
import { NavLink } from 'react-router-dom';
import maincss from './MainCSS.module.css';

const Navbar = () => {
    return (
        <header style={{position : "sticky", top: 0}}>
            <nav className={maincss.header}>
                <h1>Citywide Tech. Ltd Client Management</h1>
                <NavLink to="/addClient">Add Client</NavLink>
                <NavLink to="/allClients">All Clients</NavLink>
                <NavLink to="/">Dashboard</NavLink>
            </nav>
        </header>
    );
}
 
export default Navbar;